import React, { createContext, Component } from "react";
import { getDoctorAccount } from "./Helpers";

const UserContext = createContext();

class UserProvider extends Component {
  // Context state
  state = {
    userPhoto: getDoctorAccount()?.photo_url,
    userName: getDoctorAccount()?.doctor_name,
    userLoggedIn: false,
  };

  // Method to update state
  setUserPhoto = (photo) => {
    this.setState({ userPhoto: photo });
  };

  // Method to update state
  setUserName = (name) => {
    this.setState({ userName: name });
  };

  // Method to update state
  setUserLoggedIn = (value) => {
    this.setState({ userLoggedIn: value });
  };

  render() {
    const { children } = this.props;
    const { userPhoto, userName, userLoggedIn } = this.state;
    const { setUserPhoto, setUserName, setUserLoggedIn } = this;

    return (
      <UserContext.Provider
        value={{
          userPhoto,
          userName,
          userLoggedIn,
          setUserPhoto,
          setUserName,
          setUserLoggedIn,
        }}
      >
        {children}
      </UserContext.Provider>
    );
  }
}

export default UserContext;

export { UserProvider };
